import React from 'react';
import PropTypes from 'prop-types';

import { Col, Row } from '@zillow/zrs-comet';
import { Text, Spacer } from '@zillow/constellation';

import BillingConstants from 'app/shared/constants/BillingConstants';

import './style.scss';

const propTypes = {
    errorMsg: PropTypes.string,
};

const defaultProps = {
    errorMsg: '',
};

const BillingError = ({ errorMsg }) => (
    <div className="BillingError">
        <Row>
            <Col>
                <Spacer marginBottom="sm">
                    <Text>{errorMsg}</Text>
                </Spacer>
            </Col>
        </Row>
        <Row>
            <Col>
                <Text as="div">
                    Please contact Zillow Group Rentals.
                </Text>
                <Text as="div">
                    {`Tel: ${BillingConstants.ZRN_BILLING_PHONE}, Email ${BillingConstants.ZRN_BILLING_EMAIL}`}
                </Text>
            </Col>
        </Row>
    </div>
);

BillingError.propTypes = propTypes;
BillingError.defaultProps = defaultProps;

export default BillingError;
